import React, { useState, useEffect } from "react";
import carAuction from "../../assets/carauction.png";
import { Link, useNavigate } from "react-router-dom";
import CircularTimerAuto from "../../components/circulartimer/CircularTimerAuto.tsx";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import api from "../../lib/api.ts";

export default function AuctionVehicalsList({
  cars,
  currentVehicleId,
  currentUserId,
}) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { showSuccess, showError } = useToast();
  const [activeTab, setActiveTab] = useState("upcoming");
  const [bookmarkedVehicles, setBookmarkedVehicles] = useState(new Set());
  let filteredCars = [];

  // Fetch wishlist on component mount
  useEffect(() => {
    const fetchWishlist = async () => {
      if (!user?.id) {
        return;
      }

      try {
        const response = await api.get("/wishlist");
        
        // The API response has the structure: { data: [...], pagination: {...}, success: true }
        const wishlistData = response.data?.data || response.data;
        
        if (wishlistData && Array.isArray(wishlistData)) {
          // Extract vehicle IDs from wishlist response
          const wishlistVehicleIds = wishlistData.map(item => item.vehicleId);
          
          setBookmarkedVehicles(new Set(wishlistVehicleIds));
        }
      } catch (error) {
        // Don't show error toast for initial fetch to avoid spam
      }
    };

    fetchWishlist();
  }, [user?.id]);

  const upcomingCars = cars?.filter(
    (car) =>
      car.soldPrice == null &&
      car.soldDate == null &&
      car.soldTo == null &&
      car.productAuctionStatusId == 2
  );
  // const soldCars = cars?.filter(
  //   (car) =>
  //     car.soldPrice != null &&
  //     car.soldDate != null &&
  //     car.soldTo != null &&
  //     car.productAuctionStatusId == 3
  // );
  const underApprovalCars = cars?.filter(
    (car) =>
      car.productAuctionStatusId == 5 &&
      currentUserId &&
      car.soldTo == currentUserId
  );
  const buyNowCars = cars?.filter((car) => car.productAuctionStatusId == 4);
  const wonVehicles = cars?.filter(
    (car) => car.productAuctionStatusId == 3 && car.soldTo == currentUserId
  );

  // set filteredCars to upcomingCars if activeTab is upcoming
  if (activeTab === "upcoming") {
    filteredCars = upcomingCars;
    // } else if (activeTab === "sold") {
    //   filteredCars = soldCars;
  } else if (activeTab === "under-approval") {
    filteredCars = underApprovalCars;
  } else if (activeTab === "buy-now") {
    filteredCars = buyNowCars;
  } else if (activeTab === "won") {
    filteredCars = wonVehicles;
  }

  const TabButton = ({ label, tabName, count }) => (
    <button
      onClick={() => setActiveTab(tabName)}
      className={`px-6 py-2 rounded-full text-sm font-semibold transition-colors duration-200 ${
        activeTab === tabName
          ? "bg-orange-500 text-white"
          : "bg-transparent text-gray-700 hover:text-orange-500"
      }`}
    >
      {label}
      {count >= 0 && <span className="text-muted">({count})</span>}
    </button>
  );

  const BookmarkIcon = ({ vehicleId, isBookmarked }) => {
    return (
      <div 
        className={`w-10 h-10 flex items-center p-2 justify-center rounded-full cursor-pointer transition-colors duration-200 ${
          isBookmarked 
            ? 'bg-orange-500 text-white hover:bg-orange-600' 
            : 'bg-white text-gray-500 hover:bg-gray-200 hover:text-gray-700'
        }`}
        onClick={(e) => toggleWishlist(vehicleId, e)}
      >
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0855 18C11.7265 18 11.3875 17.9 11.0684 17.7L7.17949 15.24C7.05983 15.16 6.94017 15.16 6.82051 15.24L2.93162 17.7C2.57265 17.94 2.17379 18.03 1.73504 17.97C1.2963 17.91 0.917379 17.74 0.598291 17.46C0.19943 17.1 0 16.64 0 16.08V1.92C0 1.4 0.189459 0.950001 0.568376 0.57C0.947293 0.190001 1.39601 0 1.91453 0H12.0855C12.604 0 13.0527 0.190001 13.4316 0.57C13.8105 0.950001 14 1.4 14 1.92V16.08C14 16.6 13.8105 17.05 13.4316 17.43C13.0527 17.81 12.604 18 12.0855 18ZM7 13.62C7.35897 13.62 7.69801 13.72 8.01709 13.92L11.906 16.38C11.9459 16.42 12.0057 16.44 12.0855 16.44C12.1652 16.44 12.235 16.41 12.2949 16.35C12.3547 16.29 12.3846 16.2 12.3846 16.08V1.92C12.3846 1.8 12.3547 1.71 12.2949 1.65C12.235 1.59 12.1652 1.56 12.0855 1.56H1.91453C1.83476 1.56 1.76496 1.59 1.70513 1.65C1.6453 1.71 1.61538 1.8 1.61538 1.92V16.08C1.61538 16.2 1.66524 16.3 1.76496 16.38C1.86467 16.46 1.97436 16.46 2.09402 16.38L5.98291 13.92C6.30199 13.72 6.64103 13.62 7 13.62Z"
          fill={isBookmarked ? "#ffffff" : "#888888"}
        />
      </svg>
    </div>
    );
  };

  const checkIfCurrentVehicle = (vehicle) => {
    return vehicle.id == currentVehicleId;
  };

  // Toggle wishlist item
  const toggleWishlist = async (vehicleId, event) => {
    event.preventDefault(); // Prevent navigation when clicking bookmark
    event.stopPropagation(); // Stop event bubbling
    
    

    try {
      const response = await api.post("/wishlist/toggle", { vehicleId });

      if (response.data.success) {
        // Use the action from API response to determine the new state
        const action = response.data.data?.action;
        const isAdded = action === "added";
        
        // Update bookmarked vehicles set
        setBookmarkedVehicles(prev => {
          const newSet = new Set(prev);
          if (isAdded) {
            newSet.add(vehicleId);
          } else {
            newSet.delete(vehicleId);
          }
          return newSet;
        });

        // Show appropriate toast message based on API response
        if (isAdded) {
          showSuccess("Vehicle added to Watch List successfully!");
        } else {
          showSuccess("Vehicle removed from Watch List successfully!");
        }
      } else {
        // Show the specific API error message
        const errorMessage = response.data.message || "Failed to update Watch List. Please try again.";
        showError(errorMessage);
      }
    } catch (error) {
      console.error("Error toggling Watch List:", error);
      // Show specific error message from API response if available
      const errorMessage = error.response?.data?.message || "Failed to update Watch List. Please try again.";
      showError(errorMessage);
    }
  };

  // calculate total seconds between buyNowEndTime and current time
  // buyNowEndTime is as 2025-09-03T07:15:17.896Z
  const calculateTotalSeconds = (car) => {
    return process.env.REACT_APP_BUYNOWENDTIME_INTERVAL || 3600;
  };

  const calculateRemainingSeconds = (car) => {
    const remainingSeconds = Math.floor(
      (new Date(car.buyNowEndTime).getTime() - Date.now()) / 1000
    );
    return remainingSeconds > 0 ? remainingSeconds : 0;
  };

  return (
    <div className="bg-white rounded-lg min-h-[612px] shadow-xl max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex items-center bg-[rgba(253,235,229,1)] py-2 px-4 gap-2 mb-6">
        <img
          src={carAuction}
          alt="Auction Car"
          className="h-8 w-12 object-cover"
        />
        <h2 className="text-xl font-bold text-gray-800">ALL AUCTION CARS</h2>
      </div>

      {/* <span></span> */}
      {/* Tabs */}
      <div className="grid grid-cols-1 md:grid-cols-4 my-2 bg-[rgba(255,255,255,1)] border border-[rgba(241,90,41,1)] rounded-full p-1 ">
        <TabButton
          key="upcoming"
          label="UPCOMING"
          tabName="upcoming"
          count={upcomingCars.length - 1}
        />
        {/* <TabButton
          key="sold"
          label="SOLD"
          tabName="sold"
          count={soldCars.length}
        /> */}
        <TabButton
          key="under-approval"
          label="UNDER APPROVAL"
          count={underApprovalCars.length}
          tabName="under-approval"
        />
        <TabButton
          key="buy-now"
          label="BUY NOW"
          tabName="buy-now"
          count={buyNowCars.length}
        />
        <TabButton
          key="won"
          label="WON"
          tabName="won"
          count={wonVehicles.length}
        />
      </div>

      {/* Car List */}
      <div className="space-y-4  overflow-y-auto max-h-[480px] custom-scrollbar">
        {filteredCars &&
          filteredCars.map(
            (car) => {
              // skip if checkIfCurrentVehicle(car) is true
              if (checkIfCurrentVehicle(car)) {
                return null;
              }
              
              return (
                <div
                  key={car.id}
                  className={`border-b border-gray-300  flex items-center justify-between py-4`}
                >
                  <div className="flex items-center gap-4">
                    <img
                      src={car?.images?.[0]?.imageUrl}
                      alt={car?.name}
                      className="h-16 w-24 object-cover rounded-md cursor-pointer hover:opacity-80 transition-opacity"
                      onClick={() => window.open(`/${car.slug}`, '_blank')}
                    />
                    <div className="flex flex-col">
                      <div 
                        className="text-lg font-semibold text-gray-900 cursor-pointer hover:text-orange-500 transition-colors"
                        onClick={() => window.open(`/${car.slug}`, '_blank')}
                      >
                        {car?.name}
                      </div>
                      <div className="text-sm text-gray-500">
                        Run #: {car?.runNo} | Lot #: {car?.lotNumber} | VIN #:{" "}
                        {car?.vinNumber}
                      </div>
                      {car?.soldToBuyer?.user?.name &&
                        car?.productAuctionStatusId == 2 && (
                          <div className="w-fit rounded-full text-xs px-2 py-1 border border-green-500 text-green-500">
                            Sold to:{" "}
                            {car?.soldToBuyer?.user?.name +
                              " " +
                              car?.soldToBuyer?.user?.clientId}
                          </div>
                        )}
                      {car?.productAuctionStatus?.name && (
                        <div className="w-fit rounded-full text-xs px-2 py-1 bg-red-500 text-white">
                          {car?.productAuctionStatus?.name}
                        </div>
                      )}
                      {activeTab == "buy-now" && (
                        <div className="mt-3 text-xl font-bold text-primary">
                          Price: {car?.buyNowPrice}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    {activeTab == "buy-now" && (
                      <div>
                        <CircularTimerAuto
                          totalSeconds={calculateTotalSeconds(car)}
                          remainingSeconds={calculateRemainingSeconds(car)}
                          autoCalculateTime={true}
                          strokeWidth={6}
                          size={90}
                          timerFontSize={18}
                        />
                        {activeTab == "buy-now" && (
                          <div>
                            <button className="mt-3 w-fit rounded-md px-3 py-1 bg-red-500 text-white">
                              Buy Now
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                    {activeTab != "buy-now" && (
                      <BookmarkIcon 
                        vehicleId={car.id} 
                        isBookmarked={bookmarkedVehicles.has(car.id)} 
                      />
                    )}
                  </div>
                </div>
              );
            }
          )}
      </div>
    </div>
  );
}
